import { QuestionConfig } from "../../data/QuestionConfig.ts";
import { useTranslation } from "react-i18next";
import image from '/src/assets/images/tabelle_einsatzbereiche.png';
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";


export default function InfoPopupContent({ questionConfig }: { questionConfig: QuestionConfig }) {
    const { t, i18n } = useTranslation();
    const [privacyContent, setPrivacyContent] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    // Funktion zum Laden des Markdown-Inhalts für die Datenschutzerklärung
    useEffect(() => {
        if (questionConfig.questionId === "privacy_agreement") {
            setLoading(true);
            // Verwende den übersetzten Link aus den Lokalisierungen
            fetch(t('url_privacy_agreement_infotext'))
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Fehler beim Laden der Datenschutzerklärung: ${response.status}`);
                    }
                    return response.text();
                })
                .then(data => {
                    setPrivacyContent(data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error("Fehler beim Laden der Datenschutzerklärung:", err);
                    setError(err.message);
                    setLoading(false);
                });
        }
    }, [questionConfig.questionId, i18n.language, t]); // Wir fügen i18n.language als Abhängigkeit hinzu, damit bei Sprachwechsel neu geladen wird

    if(questionConfig.questionId === "bicycle_type") {
        return (
            <div style={{textAlign: 'center'}}>
                <img
                    src={image}
                    alt="tabelle_einsatzbereiche"
                    style={{width: '100%', height: 'auto', display: 'block', margin: '0 auto'}} // Bild zentrieren
                />
            </div>
        );
    } else if (questionConfig.questionId === "sitbone_distance") {
        return (
            <div style={{ textAlign: 'center' }}>
                {/* Verlinkungen über dem Video */}
                <div>
                    <a href={t('url_sit_bone_measurement')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_sit_bone_measurement')}
                    </a>
                    <a href={t('url_measurement_kit')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_measurement_kit')}
                    </a>
                </div>

                {/* Eingebettetes YouTube-Video */}
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',           // Volle Breite des Containers
                        paddingTop: '56.25%',    // 16:9 Aspect Ratio (9 / 16 = 0.5625 oder 56.25%)
                        margin: '20px auto'      // Zentrieren mit Abstand oben/unten
                    }}
                >
                    <iframe
                        src={t('url_video_sit_bone')}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 0
                        }}
                    ></iframe>
                </Box>
            </div>
        );
    } else if (questionConfig.questionId === "hand_size_measurement") {
        return (
            <div style={{textAlign: 'center'}}>
                {/* Verlinkung Handvermessung - über den Videos */}
                <div>
                    <a href={t('url_hand_measurement')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_hand_measurement')}
                    </a>
                </div>

                {/* Eingebettetes YouTube-Video für Griffweite */}
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',           // Volle Breite des Containers
                        paddingTop: '56.25%',    // 16:9 Aspect Ratio
                        margin: '20px auto'      // Zentrieren mit Abstand
                    }}
                >
                    <iframe
                        src={t('url_video_grip_width')}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 0
                        }}
                    ></iframe>
                </Box>

                {/* Eingebettetes YouTube-Video für Handbreite */}
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',           // Volle Breite des Containers
                        paddingTop: '56.25%',    // 16:9 Aspect Ratio
                        margin: '20px auto'      // Zentrieren mit Abstand
                    }}
                >
                    <iframe
                        src={t('url_video_hand_width')}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 0
                        }}
                    ></iframe>
                </Box>
            </div>
        );
    } else if (questionConfig.questionId === "foot_type") {
        return (
            <div style={{textAlign: 'center'}}>
                {/* Verlinkung Fußvermessung - über dem Video */}
                <div>
                    <a href={t('url_foot_measurement')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_foot_measurement')}
                    </a>
                </div>

                {/* Eingebettetes YouTube-Video für Fußvermessung */}
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',           // Volle Breite des Containers
                        paddingTop: '56.25%',    // 16:9 Aspect Ratio
                        margin: '20px auto'      // Zentrieren mit Abstand
                    }}
                >
                    <iframe
                        src={t('url_video_foot_measurement')}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 0
                        }}
                    ></iframe>
                </Box>
            </div>
        );
    } else if (questionConfig.questionId === "pelvic_problems") {
        return (
            <div style={{textAlign: 'center'}}>
                {/* Verlinkungen für Beckenbeschwerden */}
                <div>
                    <a href={t('url_numbness')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_numbness')}
                    </a>
                    <a href={t('url_back_pain')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_back_pain')}
                    </a>
                    <a href={t('url_sit_bone_pain')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_sit_bone_pain')}
                    </a>
                    <a href={t('url_coccyx_pain')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_coccyx_pain')}
                    </a>
                    <a href={t('url_pubic_arch')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_pubic_arch')}
                    </a>
                    <a href={t('url_prostate')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_prostate_problems')}
                    </a>
                </div>
            </div>
        );
    } else if (questionConfig.questionId === "hand_problems") {
        return (
            <div style={{textAlign: 'center'}}>
                {/* Verlinkungen für Handbeschwerden */}
                <div>
                    <a href={t('url_numb_fingers')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_numb_fingers')}
                    </a>
                    <a href={t('url_painful_hands')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_painful_hands')}
                    </a>
                    <a href={t('url_grip_security')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_grip_security')}
                    </a>
                    <a href={t('url_shoulder_neck')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_shoulder_neck')}
                    </a>
                </div>
            </div>
        );
    } else if (questionConfig.questionId === "foot_problems") {
        return (
            <div style={{textAlign: 'center'}}>
                {/* Verlinkungen für Fußbeschwerden */}
                <div>
                    <a href={t('url_numb_toes')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_numb_toes')}
                    </a>
                    <a href={t('url_burning_soles')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_burning_soles')}
                    </a>
                    <a href={t('url_knee_pain')} target="_blank" rel="noopener noreferrer" style={{ display: 'block', margin: '10px 0' }}>
                        {t('link_knee_pain')}
                    </a>
                </div>
            </div>
        );
    } else if (questionConfig.questionId === "foot_position") {
        return (
            <div style={{textAlign: 'center'}}>
                {t('foot_position_info')}
            </div>
        );
    } else if (questionConfig.questionId === "privacy_agreement") {
        return (
            <div style={{  maxHeight: '70vh', height: '50vh', overflowY: 'auto' }}>
                {loading && <p>{t('loading_privacy_statement')}</p>}
                {error && (
                    <div style={{ color: 'red' }}>
                        <p>{t('error_loading_privacy_statement')}:</p>
                        <p>{error}</p>
                    </div>
                )}
                {!loading && !error && (
                    <ReactMarkdown>
                        {privacyContent}
                    </ReactMarkdown>
                )}
            </div>
        );
    }

    return (<div></div>);
}